// src/pages/CoursesPage.jsx
import React, { useEffect, useState } from "react";
import CoursesLayout from "../components/CoursesLayout.jsx";
import "../styles/courses.css";

export default function CoursesPage({ data: outerData }) {
  const [innerData, setInnerData] = useState(null);
  const data = outerData || innerData;

  useEffect(() => {
    if (outerData) return;
    (async () => {
      const res = await fetch("/content.json", { cache: "no-cache" });
      const json = await res.json();
      setInnerData(json);
    })().catch(console.error);
  }, [outerData]);

  if (!data) return null;

  // content.json의 courses.cards 사용 (없으면 예비 카드)
  const cards =
    data?.courses?.cards
  || data?.services?.cards   // ← services.cards도 허용
  ||    [
      {
        title: "프리다이빙",
        desc: "장비 없이 무호흡 상태로 수중에서 즐길 수 있는 과정입니다.",
        img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1200&q=80",
        // url: "https://example.com/freediving"
      },
      {
        title: "스쿠버다이빙",
        desc: "장비를 착용 후 깊은 바다로 탐험할 수 있는 과정입니다.",
        img: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=1200&q=80",
        // url: "https://example.com/scuba"
      },
      {
        title: "EFR 응급처치",
        desc: "다이빙이지의 체계적인 EFR 응급처치 과정을 소개합니다.",
        img: "https://images.unsplash.com/photo-1512678080530-7760d81faba6?auto=format&fit=crop&w=1200&q=80",
        // url: "#"
      },
      {
        title: "기타 영법 강습",
        desc: "입영 및 부족한 영법 집중 훈련 과정입니다.",
        img: "https://images.unsplash.com/photo-1505764706515-aa95265c5abc?auto=format&fit=crop&w=1200&q=80",
        // url: "#"
      },
    ];

  // url/href/link 키 호환 + 빈값 처리
  const getUrl = (c) => (c?.url ?? c?.href ?? c?.link ?? "").trim();
  const isClickable = (c) => {
    const u = getUrl(c);
    return u !== "" && u !== "#";
  };
  const openInNewTab = (url) => {
    if (!url || url === "#") return; // 빈 링크면 아무 것도 안함
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="courses-page">
      <CoursesLayout data={data}>
        <section className="courses-section">
          <div className="container">
            <header className="courses-header">
              <h2>강습 과정</h2>
              <p>다이빙이지는 다양한 전문 교육과 실전 경험으로 상시 운영합니다.</p>
            </header>

            <div className="course-grid">
              {cards.map((c, i) => {
                const clickable = isClickable(c);
                const url = getUrl(c);
                return (
                  <article key={i} className="course-card">
                    <button
                      type="button"
                      className="as-button"
                      aria-label={`${c.title} 자세히 보기`}
                      onClick={() => clickable && openInNewTab(url)}
                      onKeyDown={(e) => {
                        if (!clickable) return;
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openInNewTab(url);
                        }
                      }}
                      title={clickable ? "새 창에서 열기" : undefined}
                      style={{
                        cursor: clickable ? "pointer" : "default",
                      }}
                    >
                      <div className="thumb">
                        <img src={c.img} alt={c.title} />

                        {/* 중앙 VIEW MORE (클릭 가능할 때만 보이게 하려면 아래 주석 해제) */}
                        {/* {clickable && ( */}
                        <div
                          aria-hidden="true"
                          style={{
                            position: "absolute",
                            inset: 0,
                            display: "grid",
                            placeItems: "center",
                            pointerEvents: "none",
                            zIndex: 4,
                            opacity: clickable ? 1 : 0.4,
                          }}
                        >
                          <div
                            className="viewmore"
                            style={{
                              position: "static",
                              transform: "none",
                              left: "auto",
                              top: "auto",
                            }}
                          >
                            VIEW<br />MORE
                          </div>
                        </div>
                        {/* )} */}

                        {/* 캡션 */}
                        <div className="caption">
                          <span className="caption-bg" aria-hidden="true" />
                          <h3>{c.title}</h3>
                          <p>{c.desc}</p>
                        </div>
                      </div>
                    </button>
                  </article>
                );
              })}
            </div>
          </div>
        </section>
      </CoursesLayout>
    </div>
  );
}
